// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3wn7o","select":"Header_select__3Xznl","clinic":"Header_clinic__c6VYW"};